import { isFixtureMode } from "./memberService";
import { invokeFunction } from "./supabase";
import type { PayoutRequest, PayoutStatus } from "./workflowTypes";

async function fixtures() {
  if (!import.meta.env.DEV) throw new Error("Development fixtures are unavailable in production.");
  return import("./workflowFixtures");
}

export async function listAdminPayouts(): Promise<Array<PayoutRequest & { memberHandle: string }>> {
  if (isFixtureMode) {
    const api = await fixtures();
    return api.listFixturePayouts().map((item) => ({ ...item, memberHandle: api.fixturePayoutMemberHandle }));
  }
  const result = await invokeFunction<{ payouts: Array<{
    id: string; amount_usd: number; method: PayoutRequest["method"]; destination_masked: string;
    status: PayoutStatus; requested_at: string; provider_reference?: string;
    guardian_required: boolean; guardian_approved: boolean; profiles?: { handle?: string };
  }> }>("manage-payout", { action: "list" });
  return result.payouts.map((item) => ({
    id: item.id,
    amountUsd: Number(item.amount_usd),
    method: item.method,
    destinationMasked: item.destination_masked,
    status: item.status,
    requestedAt: item.requested_at,
    providerReference: item.provider_reference,
    guardianRequired: item.guardian_required,
    guardianApproved: item.guardian_approved,
    memberHandle: item.profiles?.handle ?? "Member",
  }));
}

export async function getPayoutDestination(id: string) {
  if (isFixtureMode) return { destination: (await fixtures()).fixturePayoutDestination, method: "wise" };
  return invokeFunction<{ destination: string; method: PayoutRequest["method"] }>("manage-payout", { action: "details", id });
}

export async function updatePayoutStatus(id: string, status: PayoutStatus, providerReference?: string, failureReason?: string) {
  if (isFixtureMode) return (await fixtures()).updateFixturePayout(id, status, providerReference);
  await invokeFunction("manage-payout", { action: "update", id, status, providerReference, failureReason });
}
